export default __webpack_public_path__ + "static/media/6.a7bd00e5.png";